export enum TEXT_MARRIAGE_LAW {
  PrimaParte = 'Gli sposi, alla presenza degli stessi testimoni, mi hanno dichiarato di scegliere la legge',
  ChiusuraTesto = "da applicare ai loro rapporti patrimoniali, ai sensi dell'articolo 30, primo comma, della legge 31 maggio 1995, n. 218.",
}

export enum TEXT_UNION_CIVIL_LAW {
  PrimaParte = 'Le persone da unire civilmente, alla presenza degli stessi testimoni, mi dichiarano anche di scegliere la legge',
  ChiusuraTesto = "da applicare ai loro rapporti patrimoniali, ai sensi dell'art. 30, primo comma, della legge 31 maggio 1995, n. 218 e dell'art. 70-quaterdecies, secondo comma, del D.P.R. 3 novembre 2000, n. 396.",
}

export const TEXT_UNION_CIVIL_SEPARATION =
  "Con dichiarazione resa nell'atto di unione civile controscritto, le persone da unire civilmente hanno dichiarato di scegliere il regime della separazione dei beni.";

export const TEXT_SEPARATION_ASSETS =
  "Con dichiarazione resa nell'atto di matrimonio controscritto, gli sposi hanno scelto il regime della separazione dei beni.";

export enum TEXT_WEDDING_AGREEMENTS {
  Data = 'Con atto in data',
  Rep = 'Rep.',
  Racc = 'Racc.',
  NomeCognome = 'a rogito del notaio',
  Distretto = 'del distretto notarile di',
  ChiusuraTestoMatrimonio = 'gli sposi hanno stipulato convenzioni matrimoniali.',
  ChiusuraTestoUnioneCivile = 'gli uniti civilmente hanno stipulato convenzioni patrimoniali.',
}
